import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient, HttpEvent} from "@angular/common/http";
import {Observable} from "rxjs";
import {InterventionRequest} from "./InterventionRequest";

@Injectable({ providedIn: 'root' })
export class InterventionRequestService {
  private apiV1: string = environment.apiV1;
  private baseRef: string = environment.origin;
  private serviceRef: string = environment.service.core;

  constructor(
    private httpClient: HttpClient
  ) { }

  public getAllByCustomerId(customerId: string): Observable<InterventionRequest[]> {
    return this.httpClient.get<InterventionRequest[]>(`${this.baseRef}${this.serviceRef}${this.apiV1}interventions/requests/customer/${customerId}`);
  }

  public createOne(formValue: InterventionRequest): Observable<InterventionRequest> {
    return this.httpClient.post<InterventionRequest>(`${this.baseRef}${this.serviceRef}${this.apiV1}interventions/requests`, formValue);
  }

}
